// extracted by mini-css-extract-plugin
export default {"container":"CardFooter_container__VIJc0","toggle":"CardFooter_toggle__Ude9E","options":"CardFooter_options__31syH"};